import type { AxiosInstance } from 'axios'
import type { IArticleService } from "./article.type"
import axios from '@/api/axios'
import type { IArticleData } from "@/models/knowledge_base"

export class ArticleService implements IArticleService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/knowledge-base/'
  }

  async fetchArticles(): Promise<IArticleData[]> {
    return this.axios.get(this.endpoint)
      .then(({ data }) => data)
  }
}

// Default export instantiation of the ArticleService
const articleService = new ArticleService(axios)
export default articleService
